import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { LogoutSuccess } from 'common';
import { fetchLogoutSuccess } from './LogoutSuccessSlice';
import { LogoutSuccessContentSelector } from './LogoutSuccessContentSelector';

export function useLogoutSuccess(): AbstractContentState<LogoutSuccess> {
    return useCmsContent(fetchLogoutSuccess, LogoutSuccessContentSelector);
}
